const OFFERS_URL = '/offers';
const OFFER_PRICES_URL = '/offer-prices';

export function offersApi(offerId?: string) {
  if (offerId) {
    return `${OFFERS_URL}/${offerId}`;
  }

  return OFFERS_URL;
}

export function offersShortStat() {
  return `${OFFERS_URL}/short-statistic`;
}

export function copyOffer(offerId: string) {
  return `${offersApi(offerId)}/copy`;
}

export function offerAutoBid(offerId: string) {
  return `${offersApi(offerId)}/auto-bid`;
}

export function geoListByOfferId(offerId: string) {
  return `${offersApi(offerId)}/offer-geo`;
}

export function pauseOffer(offerId: string) {
  return `${offersApi(offerId)}/pause`;
}

export function activateOffer(offerId: string) {
  return `${offersApi(offerId)}/activate`;
}

export function offerPartners(offerId: string) {
  return `${offersApi(offerId)}/partners`;
}

export function trendsManagersApi() {
  return `${OFFERS_URL}/user-statistic`;
}

export function offersTrends() {
  return `${OFFERS_URL}/trends`;
}

export function offersDevices() {
  return `${OFFERS_URL}/devices`;
}

export function offerPrices() {
  return OFFER_PRICES_URL;
}
